module.exports = "<h2 mat-dialog-title>Confirmación</h2>\r\n<mat-dialog-content>\r\n  <h3>Está seguro de eliminar este registro?</h3>\r\n  \r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n <button mat-button [mat-dialog-close]=\"true\">Si</button>\r\n <button mat-button [mat-dialog-close]=\"false\">No</button>\r\n \r\n</mat-dialog-actions>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/ParametrizarParametros/confirmacionDeleteParametro.html
// module id = ../../../../../src/app/main/content/ParametrizarParametros/confirmacionDeleteParametro.html
// module chunks = main